export const DRAFTS_LATS_ERROR = 'DRAFTS_LATS_ERROR';